import { colors } from '@mui/material';

const styles = {
  root: {
    backgroundColor: colors.grey[50]
  }
};

export default styles